// components/SearchBar.jsx
import React from 'react';
import { Search } from 'lucide-react';

const SearchBarAdmin = ({ className }) => (
    <div className={`relative w-full max-w-xl ${className}`}>
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center">
            <Search className="h-5 w-5 text-gray-400" />
        </div>
        <input
            type="text"
            placeholder="Rechercher..."
            className="w-full pl-10 pr-4 py-2 rounded-lg border border-[#96B734] focus:outline-none focus:ring-2 focus:ring-[#96B734] bg-[#F4F8E9]"
        />
    </div>
);

export default SearchBarAdmin;